import {
  matchBatterySetupSearch,
  type BatterySetupSearchEntry,
} from "./battery-setup-search"
import { EXPORT_BLOCKED_POPUP_PROMPT } from "./ExportBrochureAction"
import { ProposalSetupQuickSearch } from "../../ProposalSetup/ProposalSetupQuickSearch"

export const BatterySetupQuickSearch = ({
  entries,
  exportPopupBlocked,
  onActivate,
  onClose,
  query,
  setQuery,
}: {
  readonly entries: readonly BatterySetupSearchEntry[]
  readonly exportPopupBlocked: boolean
  readonly onActivate: (entry: BatterySetupSearchEntry) => void
  readonly onClose: () => void
  readonly query: string
  readonly setQuery: (query: string) => void
}): JSX.Element | null => (
  <ProposalSetupQuickSearch
    alert={exportPopupBlocked ? EXPORT_BLOCKED_POPUP_PROMPT : null}
    emptyLabel="No matching setup steps"
    matches={matchBatterySetupSearch(query, entries).map((entry) => ({
      ...entry,
      lockedHint: entry.command.kind === `locked` ? entry.command.hint : null,
    }))}
    onActivate={onActivate}
    onClose={onClose}
    query={query}
    setQuery={setQuery}
    testId="battery-setup-quick-search"
  />
)
